import React, { useEffect, useState } from "react";
import { getFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";
import { toast } from "react-toastify";
import AcademyHead from "./AcademyHead";
import Spinner from "../../components/spinner/Spinner";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { parseStatics } from "../../function/parseStatics";
import { useLanguage } from "../../context/LanguageContext";



interface ISupplier {
  id:string,
  supplierProductTypeId: number;
  marketPlaceName: string;
  openAddress: string;
  companyName: string;
  coverImg: string;
  SupplierProductType: {
    name: string;
  };
}

interface IPromotion {
    id: string,
    supplierId: string,
    firstText: string,
    secondText: string,
    thirdText: string,
    fourthText: string,
    images: any,
    videoLink: string,
    status: boolean,
    title: string
}

const AcademyProduct: React.FC = () => {
  const { t } = useLanguage();
  const [suppliers, setSuppliers] = useState<ISupplier[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedSupplier, setSelectedSupplier] = useState<ISupplier | null>(null);
  const [supplierModal, setSupplierModal] = useState<boolean>(false);
  const [promotions, setPromotions] = useState<IPromotion[]>([]);

  const navigate = useNavigate();


  // GET SUPPLIERS
  useEffect(() => {
    const getSuppliers = async () => {
      setLoading(true);
      try {
        const response = await getFetcher(endpoints.eAcademy.getSuppliers);

        if (response.result) {
          setSuppliers(response.suppliers);
          setTimeout(() => {
            setLoading(false);
          }, 200);
        } else {
          toast.error(t('toastMessage', 'rate21'));
        }
      } catch (error) {
        console.log(error);
      }
    };

    getSuppliers();
  }, []);

//   GET PROMOTION BY SUPPLIERID
useEffect(() => {
    const getPromotion = async () => {
        try {
            const response = await getFetcher(endpoints.eAcademy.getPromotionBySupplierId.replace('{supplierId}', selectedSupplier?.id || ''));
            if(response.result) {
                setPromotions(response.promotions)
            }else {
                toast.error('Error');
            }

        } catch (error) {
            console.log(error);
        }
    }

    getPromotion();
}, [selectedSupplier]);

  //SELECTED SUPPLIER
  const handleSelectedSupplier = (supplier: ISupplier) => {
    setSelectedSupplier(supplier);
    setTimeout(() => {
      setSupplierModal(true);
    }, 300);
  }

  if (loading) {
    return <div className=" w-screen h-full"><Spinner /></div>
  }


  return (
    <div className=" flex flex-col gap-y-4 px-2 mb-20">
      <div>
        <AcademyHead title={"ECZA AKADEMİ TANITIM"} />
      </div>

        {/* SUPPLIERS */}
        <div className="h-full p-2  grid grid-cols-1  2xl:grid-cols-2 gap-5">
            {suppliers?.map((supplier: ISupplier, i: number) => {
            return (
                <div
                onClick={() => handleSelectedSupplier(supplier)}  
                key={i}
                className="h-full lg:h-[350px] xl:h-[300px] rounded-xl shadow-lg hover:shadow-2xl cursor-pointer transition-all transform active:scale-95 w-full "
                >
                <div className=" flex flex-col gap-y-2">
                    <div className=" w-full h-full bg-white border-b flex justify-center items-center rounded-t-xl ">
                    <img
                        className="h-[175px] lg:h-[150px] w-1/3 rounded-t-xl object-contain"
                        src={supplier.coverImg}
                        alt={supplier.coverImg}
                    />
                    </div>
                    <div className=" p-1 flex flex-col gap-y-2  ">
                    <div className=" flex flex-col lg:flex-row gap-x-3 text-sm ">
                        <p className="min-w-20 lg:min-w-32">Şirket Adı:</p>
                        <p className=" font-bold">{supplier.companyName}</p>
                    </div>
                    <div className=" flex flex-col lg:flex-row gap-x-3 text-sm ">
                        <p className="min-w-20 lg:min-w-32">Şirket Adresi:</p>
                        <p className=" font-bold">{supplier.openAddress}</p>
                    </div>
                    <div className=" flex flex-col lg:flex-row gap-x-3 text-sm ">
                        <p className="min-w-20 lg:min-w-32">Şirket Ürün Tipi:</p>
                        <p className=" font-bold">
                        {supplier.SupplierProductType.name}
                        </p>
                    </div>
                    <div className=" flex flex-col lg:flex-row gap-x-3 text-sm ">
                        <p className="min-w-20 lg:min-w-32">Market Adı:</p>
                        <p className=" font-bold">{supplier.marketPlaceName}</p>
                    </div>
                    </div>
                </div>
                </div>
            );
            })}
        </div>

        {/* SUPPLIER MODAL */}
        {supplierModal && (
            <div className="w-full h-full fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50">
            <div onClick={() => setSupplierModal(false)} className="w-full h-full absolute"></div>
            
            <div
              className="w-11/12 lg:w-9/12 xl:w-11/12 h-5/6 bg-white flex flex-col justify-start items-start rounded-xl relative p-4 overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Title */}
              <div className="w-full flex justify-center items-center mb-6">
                <h3 className="font-bold text-primary-color text-2xl text-center mt-4">
                  {selectedSupplier?.marketPlaceName} Tedarikçisinin Ürün Tanıtımları
                </h3>
              </div>

          
              {/* Promotion Grid */}
              <div className={`${promotions?.length > 0 ? 'border-gray-300 p-4 w-full rounded-xl grid grid-cols-1 sm:grid-cols-2 gap-6' : 'border-gray-300 p-4 w-full rounded-xl grid grid-cols-1 gap-6'}`}>
                {promotions?.length > 0 ? (
                  promotions?.map((item: IPromotion, i: number) => {
                    const parsedImage = parseStatics(item.images);
                    return (
                      <div 
                        onClick={() => navigate(`/academy/product-detail/${item.id}`)} 
                        key={i} 
                        className="rounded-xl shadow-lg flex flex-col lg:flex-row hover:shadow-2xl cursor-pointer transition-all overflow-hidden w-full"
                      >
                        <div className="flex-1 h-[250px] sm:h-[200px] w-full">
                          <img
                            className="h-full w-full object-contain rounded-l-xl"
                            src={parsedImage[0]}
                            alt={item.title}
                          />
                        </div>
          
                        <div className="flex-1 p-4">
                          <div className="flex flex-col gap-y-2 justify-start items-start h-full">
                            <p className="font-semibold">{item?.title}</p>
                            <p className="text-gray-600">
                              {item.firstText.substring(0, 150)}...
                            </p>
                            <button className="mt-auto text-primary-color">
                              Detaylar için tıklayınız
                            </button>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="flex flex-col justify-center items-center w-full h-[600px]">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-12 h-12 text-gray-500">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 18.364A9 9 0 0 0 5.636 5.636m12.728 12.728A9 9 0 0 1 5.636 5.636m12.728 12.728L5.636 5.636" />
                    </svg>
                    <p className="font-bold text-primary-color text-lg mt-4">Mevcut ürün tanıtımı yok</p>
                  </div>
                )}
              </div>
          
              {/* Close Button */}
              <div className="absolute top-2 right-2">
                <IoClose
                  onClick={() => setSupplierModal(false)}
                  className="text-primary-color text-2xl cursor-pointer"
                />
              </div>
            </div>
            </div>
          
        )}


    </div>
  );
};

export default AcademyProduct;
